export default {
    BRAND_NAME: "361 Selektor",
}